import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=fcbc05a8"
import script from "./MessageText.vue?vue&type=script&lang=js"
export * from "./MessageText.vue?vue&type=script&lang=js"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=fcbc05a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports